import React, {Fragment, useEffect} from 'react';
import {NavLink, Layout, Activities, Route, Switch, Today, PlanMyWeek} from 'components';
import {config, useLocation} from 'helpers';
import {reset} from 'store/calendar';

export function Router() {
  const {pathname} = useLocation();
  const isOther = /morning-routine|evening-routine|timelog|tracking/.test(pathname);
  const isPlanMyWeek = pathname.includes('/plan-my-week/');

  useEffect(reset, []);
  return (
    <Fragment>
      <Layout.Title>Today</Layout.Title>
      {isPlanMyWeek ?
        <Layout.Topbar.Tabs>
          <NavLink
            to="/today/plan-my-week/start"
            isActive={(match, location) => {
              return location.pathname.startsWith('/today/plan-my-week/start') ||
                location.pathname.includes('/plan-my-week/weekly-objective/edit/');
            }}>
            Weekly Objectives
          </NavLink>
          <NavLink to="/today/plan-my-week/activities">Activities</NavLink>
          <NavLink to="/today/plan-my-week/reflections">Reflections</NavLink>
        </Layout.Topbar.Tabs>
        :
        <Layout.Topbar.Tabs>
          <NavLink to="/today/" exact={isOther}>My Day</NavLink>
          <NavLink to="/today/morning-routine/">{config.morningRoutine}</NavLink>
          <NavLink to="/today/evening-routine/">{config.eveningRoutine}</NavLink>
          <NavLink to="/today/timelog/">Time Log</NavLink>
          <NavLink to="/today/tracking/">Tracking</NavLink>
        </Layout.Topbar.Tabs>
      }
      <Today.Toolbar/>
      <Switch>
        <Route path="/today/:type(morning|evening)-routine/plan" component={Today.RoutinePlanSidebar}/>
        {/*<Route path="/today/:type(morning|evening)-routine" component={Today.RoutineSidebar} />*/}
        <Route path="/:module(today)/" exact component={Today.Sidebar}/>
      </Switch>
      <main>
        <Switch>
          <Route path="/today/plan-my-week/start" component={PlanMyWeek.Start}/>
          <Route path="/today/plan-my-week/activities" component={PlanMyWeek.PlanMyWeekActivities}/>
          <Route path="/today/plan-my-week/reflections" component={PlanMyWeek.Reflections}/>
          <Route path="/today/plan-my-week/weekly-objective/edit/:id/" component={PlanMyWeek.WeeklyObjectiveEdit}/>
          <Route path="/today/:type(morning|evening)-routine/plan" component={Today.RoutinePlan}/>
          <Route path="/today/morning-routine/" component={Today.MorningRoutine}/>
          <Route path="/today/evening-routine/" component={Today.EveningRoutine}/>
          <Route path="/:module(today)/tracking" component={Today.Tracking}/>
          <Route path="/:module(today)/timelog" component={Today.Timelog}/>
          <Route path="/:module(today)/" component={Today.Home}/>
          <Route path="/:module(today)/:id/" component={Activities.Single.Router}/>
          <Route path="/:module(today)/" component={Today.Home}/>
        </Switch>
      </main>
    </Fragment>
  );
}
